import useSWR from 'swr';

import {
  getUrgentCasesDashboard,
  type GetUrgentCasesDashboardParams,
  type UrgentCasesDashboardResponse,
} from '@/api/urgent-cases';
import { ENDPOINTS } from '@/api/endpoints';
import { StandardResponse } from '@/api/standard-response';
import { isDevEnv } from '@/libs/dev-logs';
import { useUserProfile } from '@/states/user-profile/use-user-profile';
import { ROLES } from '@/utils/constants';

const ALLOWED_ROLES: ROLES[] = ['vitaziadmin'];

type Key = [string, GetUrgentCasesDashboardParams | undefined];

export function useGetUrgentCasesDashboard(params?: GetUrgentCasesDashboardParams) {
  const { profile } = useUserProfile();
  const hasAccess = !!profile.role && ALLOWED_ROLES.includes(profile.role);

  const { data, error, isLoading, mutate } = useSWR<
    StandardResponse<UrgentCasesDashboardResponse>,
    Error,
    Key | null
  >(
    hasAccess ? [ENDPOINTS.URGENT_CASES_DASHBOARD, params] : null,
    ([, p]: Key) => getUrgentCasesDashboard(p),
    {
      errorRetryCount: 1,
      revalidateOnFocus: !isDevEnv(),
      refreshInterval: 30000,
    }
  );

  return {
    dashboard: data?.data,
    loading: isLoading,
    error,
    mutate,
  };
}
